import React from 'react'
import { t } from 'ttag'

import Form from '../../../form/Form'
import Field from '../../../form/Field'

const FileQuestionForm = ({ onSave, onCancel }) => {
  const formModel = 'survey.surveyForms.surveyFileQuestionForm'
  const model = path => `${formModel}.${path}`

  return (
    <Form
      model={formModel}
      onSubmit={form => {
        onSave(form)
      }}>
      {form => (
        <div>
          <Field
            model={model(`name`)}
            form={form}
            required={true}
            label={t`Question Title`}
            type="text"
          />

          <Field
            model={model(`description`)}
            form={form}
            label={t`Description`}
            type="textarea"
          />

          <Field
            model={model(`responseRequired`)}
            form={form}
            label={t`Response Required`}
            type="checkbox"
          />

          <div className="nav" style={{ marginTop: '1em' }}>
            <input type="submit" className="submit" value={t`Save Question`} />
            &nbsp;
            <button type="button" onClick={onCancel} className="cancel">
              {t`Cancel`}
            </button>
          </div>
        </div>
      )}
    </Form>
  )
}

export default FileQuestionForm
